import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

// Auth
export const authMe = () => api.get('/auth/me').then(r => r.data);
export const authSession = (sid, ref) => api.get('/auth/session', { params: { session_id: sid, ...(ref ? { ref } : {}) } }).then(r => r.data);
export const authLogout = () => api.post('/auth/logout').then(r => r.data);

// Meals
export const analyzeMeal = (imageBase64) => api.post('/meals/analyze', { image_base64: imageBase64 }).then(r => r.data);
export const analyzeBarcode = (barcode, grams) => api.post('/meals/barcode', { barcode, grams }).then(r => r.data);
export const saveMeal = (meal) => api.post('/meals', meal).then(r => r.data);
export const mealsToday = () => api.get('/meals/today').then(r => r.data);
export const mealsHistory = (days = 7) => api.get('/meals/history', { params: { days } }).then(r => r.data);
export const deleteMeal = (id) => api.delete(`/meals/${id}`).then(r => r.data);

// Payments
export const checkout = (lookup_key) => api.post('/payments/checkout', { lookup_key, origin_url: window.location.origin }).then(r => r.data);
export const paymentStatus = (session_id) => api.get(`/payments/status/${session_id}`).then(r => r.data);

// Subscription
export const cancelSubscription = () => api.post('/subscription/cancel').then(r => r.data);
export const resumeSubscription = () => api.post('/subscription/resume').then(r => r.data);

// Quota & streak
export const getQuota = () => api.get('/user/quota').then(r => r.data);
export const getStreak = () => api.get('/user/streak').then(r => r.data);

// Referral & profile
export const getReferral = () => api.get('/user/referral').then(r => r.data);
export const updateProfile = (payload) => api.put('/user/profile', payload).then(r => r.data);

// Push notifications
export const getVapidKey = () => api.get('/push/vapid-key').then(r => r.data);
export const pushSubscribe = (payload) => api.post('/push/subscribe', payload).then(r => r.data);
export const pushUnsubscribe = (payload) => api.post('/push/unsubscribe', payload).then(r => r.data);

// Recipes
export const listRecipes = (params) => api.get('/recipes', { params }).then(r => r.data);
export const getRecipe = (id) => api.get(`/recipes/${id}`).then(r => r.data);
export const logRecipe = (id, servings = 1) => api.post(`/recipes/${id}/log`, { servings }).then(r => r.data);
export const getRecipeTags = () => api.get('/recipes/tags').then(r => r.data);
export const suggestFromPhoto = (imageBase64, preferences) => api.post('/recipes/from-photo', { image_base64: imageBase64, preferences }).then(r => r.data);
export const savePreference = (payload) => api.post('/preferences', payload).then(r => r.data);
